/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import vars from "Consts/vars";
import CardSearchArticle from "@fdn/card_search_article";
import CardSearchUser from "@fdn/card_search_user";
import NextImage from "Components/fallback_image/next_image";
import CardSearchBrand from "@fdn/card_search_brand";
import CardSearchProduct from "@fdn/card_search_product";

const Mobile = (props) => {

	const prop = props;
	const filterProduct = Array.isArray(prop.dataBrand) ? prop.dataBrand?.filter((data) => (data.type === "product")) : [];
	const filterService = Array.isArray(prop.dataBrand) ? prop.dataBrand?.filter((data) => (data.type === "service")) : [];

	return (
		<div className="component-tab-all">
			{!prop.dataArticle?.length && !prop.dataProduct?.length && !prop.dataBrand?.length
				&& !prop.dataArticle?.length && !prop.dataUser?.length ? (
					<div className="component-tab-all__section-image-error">
						<img src="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/error-image/image-no-result.png" alt="page error" className="component-tab-topic__image-error" />
						<h4 className="component-tab-topic__title">Sorry, no result found</h4>
						<p className="component-tab-topic__sub_title">Please try another keyword!</p>
					</div>
				) : (
					<>
						{
							!Array.isArray(prop.dataProduct) || prop.dataProduct?.length === 0 ? (

								<p className="component-tab-all_not-matching">
									Sorry, we couldn&apos;t find any product matching with
									{" "}
									<q>{prop.keyword}</q>
								</p>
							)
								: Array.isArray(prop.dataProduct) && prop.dataProduct?.length && (
									<>
										<div className="component-tab-all__section-title">
											<p className="component-tab-all__title title-product">Products</p>
											{prop.dataProduct.length > 0 && (
												<button className="component-tab-all__button-view-all" type="button" onClick={() => prop.onClickTab(vars.SEARCH_TAB.PRODUCT)}>View All</button>
											)}
										</div>
										<div className="component-tab-all__product">

											{Array.isArray(prop.dataProduct)
											&& prop.dataProduct?.filter((data, index) => index < prop.limitDataProduct)
												.map((dataProduct) => (
													<CardSearchProduct
														key={dataProduct?.id}
														isMobile={prop.isMobile}
														maxWidth="180px"
														data={{
															variant: dataProduct?.name,
															name: dataProduct?.product?.name || "-",
															brand: dataProduct?.brand?.name || "-",
															image: dataProduct?.assets[0].url || vars.no_image,
															rating: dataProduct?.rating?.rating_overall || 0,
															totalRating: dataProduct?.total_review || 0,
															url: Array.isArray(dataProduct?.categories)
															&& dataProduct?.categories.length > 0
																? `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/products/${dataProduct?.categories[0]?.parent?.slug}/
																${dataProduct?.categories[0]?.slug}/${dataProduct?.brand?.slug}/${dataProduct?.slug}`
																: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
														}}
													/>

												))}
										</div>

									</>

								)
						}
						{
							prop.dataService && (
								<>
									<div className="component-tab-all__section-title">
										<p className="component-tab-all__title title-services">Salon & Clinic</p>
										{prop.dataService.length > 0 && (
											<button className="component-tab-all__button-view-all" type="button" label="products" onClick={() => prop.onClickTab("Salon & Clinic")}>View All</button>
										)}
									</div>
									{
										!Array.isArray(prop.dataService) || prop.dataService?.length === 0 ? (

											<div className="component-tab-all_not-matching">
												Sorry, we couldn&apos;t find any salon & clinic matching with
												{" "}
												<q>
													{prop.keyword}
												</q>
											</div>
										) : (
											<div className="component-tab-all__product">
												{
													Array.isArray(prop.dataService) && prop.dataService?.filter(
														(data, index) => index < prop.limitDataService,
													)
														.map((dataService) => (
															<CardSearchProduct
																key={dataService?.id}
																isMobile={prop.isMobile}
																maxWidth="200px"
																data={{
																	name: dataService?.name || "-",
																	brand: dataService?.service?.name || "-",
																	image: dataService?.assets[0].url || vars.no_image,
																	rating: dataService?.rating?.rating_overall || 0,
																	totalRating: dataService?.total_review || 0,
																	url: Array.isArray(dataService?.categories)
																	&& dataService?.categories.length > 0
																		? `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/services/${dataService?.categories[0]?.parent?.slug}/
																		${dataService?.categories[0]?.slug}/${dataService?.brand?.slug}/${dataService?.slug}`
																		: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
																}}
															/>

														))
												}
											</div>
										)
									}

								</>

							)
						}

						{/* brand section tab all */}
						{
							prop.dataBrand.length > 0 && (
								<>
									<div className="component-tab-all__section-title">
										<p className="component-tab-all__title title-brand">Brands</p>
										<button className="component-tab-all__button-view-all" type="button" onClick={() => prop.onClickTab(vars.SEARCH_TAB.BRAND)}>View All</button>
									</div>
									{/* Condition  if both of brands have no data matches */}
									{
										!Array.isArray(prop.dataBrand) || prop.dataBrand.length === 0 ? (
											<p className="component-tab-all_not-matching">
												Sorry, we couldn&apos;t find any brands matching with
												{" "}
												<q>
													{prop.keyword}
												</q>
											</p>
										)
											: (
												<>
													{/* brand product section */}
													<div className="component-tab-all__section-subtitle">
														Product
													</div>
													{
														!Array.isArray(filterProduct) || filterProduct.length === 0
															? (
																<p className="component-tab-all_not-matching">
																	Sorry, we couldn&apos;t find any brand matching with
																	{" "}
																	<q>
																		{prop.keyword}
																	</q>
																</p>
															) : (
																<div className="component-tab-all__section-brand">

																	{
																		filterProduct.map((data, index) => index < prop.limitDataBrand
																		&& (
																			<CardSearchBrand
																				key={data?.id}
																				isMobile={prop.isMobile}
																				brokenImage={vars.BROKEN_IMAGE.square}
																				brand={{
																					name: data?.name || "-",
																					slug: data?.slug || "-",
																					type: data?.type || "-",
																					logo: data?.logo || vars.no_image,
																					url: `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands/${data?.type}/${data?.slug}`,
																				}}
																			/>

																		))
																	}

																</div>
															)
													}

													{/* brand salon section */}
													<div className="component-tab-all__section-subtitle">
														Salon & Clinic
													</div>
													{
														!Array.isArray(filterService) || filterService.length === 0 ? (
															<p className="component-tab-all_not-matching">
																Sorry, we couldn&apos;t find any brand matching with
																{" "}
																<q>
																	{prop.keyword}
																</q>
															</p>
														)
															: (

																<div className="component-tab-all__section-brand">
																	{
																		filterService.map((data, index) => index < prop.limitDataBrand
																		&& (
																			<CardSearchBrand
																				key={data?.id}
																				isMobile={prop.isMobile}
																				brokenImage={vars.BROKEN_IMAGE.square}
																				brand={{
																					name: data?.name || "-",
																					slug: data?.slug || "-",
																					type: data?.type || "-",
																					logo: data?.logo || vars.no_image,
																					url: `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands/${data?.type}/${data?.slug}`,
																				}}
																			/>

																		))
																	}
																</div>
															)
													}
												</>
											)
									}

								</>

							)
						}

						{
							Array.isArray(prop.dataArticle) && prop.dataArticle && (
								<>
									<div className="component-tab-all__section-title">
										<p className="component-tab-all__title title-article">Articles</p>
										{
											prop.dataArticle?.length > 0 && (
												<button className="component-tab-all__button-view-all" type="button" onClick={() => prop.onClickTab(vars.SEARCH_TAB.ARTICLE)}>View All</button>
											)
										}
									</div>
									<div className="component-tab-all__article">
										{
											prop.dataArticle?.length > 0
												? prop.dataArticle?.filter((data, index) => index < prop.limitDataArticle)
													.map((data) => (

														<CardSearchArticle
															key={data.id}
															isMobile={prop.isMobile}
															article={data}
														>
															<NextImage
																width={100}
																height={66}
																placeholder="article"
																objectFit="cover"
																style={{ borderRadius: 4 }}
																src={data.image}
																alt={data.title}
																fallbackSrc={vars.BROKEN_IMAGE.rectangle}
															/>
														</CardSearchArticle>

													))
												: (
													<p className="component-tab-all_not-matching">
														Sorry, we couldn&apos;t find any article matching with
														{" "}
														<q>{prop.keyword}</q>
													</p>
												)
										}
									</div>

								</>

							)
						}

						{
							Array.isArray(prop.dataUser) && prop.dataUser && (
								<>
									<div className="component-tab-all__section-title">
										<p className="component-tab-all__title title-user">Users</p>
										{
											prop.dataUser.length > 0 && (
												<button className="component-tab-all__button-view-all" type="button" onClick={() => prop.onClickTab(vars.SEARCH_TAB.USER)}>View All</button>
											)
										}
									</div>
									<div className="component-tab-all__users">
										{
											prop.dataUser.length > 0
												? prop.dataUser?.filter((data, index) => index < prop.limitDataUser)
													.map((data) => (
														<CardSearchUser
															key={data.usrapo_id}
															isMobile={prop.isMobile}
															domain={process.env.NEXT_PUBLIC_SSO_DOMAIN}
															user={data}
															brokenImage={vars.BROKEN_IMAGE.square}
														>
															<NextImage
																width={60}
																height={60}
																placeholder="user"
																objectFit="cover"
																style={{ borderRadius: "50%" }}
																src={data.usrpic || vars.BROKEN_IMAGE.user}
																alt={data.username}
																fallbackSrc={vars.BROKEN_IMAGE.user}
															/>
														</CardSearchUser>

													))
												: (
													<p className="component-tab-all_not-matching">
														Sorry, we couldn&apos;t find any user matching with
														{" "}
														<q>{prop.keyword}</q>
													</p>
												)
										}
									</div>
								</>
							)
						}
					</>
				)}

			<style>
				{`
					.newest-groups-card-description {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

				`}
			</style>
			<style jsx>
				{`


						.component-tab-all__keyword{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 400;
							font-size: 14px;
							line-height: 22px;
							color: #13161A;
							margin-top:13px;
						}
						.component-tab-all__section-title{
							display: flex;
							margin-top: 16px;
							margin-bottom: 22px;
							justify-content: space-between;
						}
						.component-tab-all__section-subtitle {
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 400;
							font-size: 14px;
							margin: 1rem 0;
						}
						.component-tab-all__title{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 16px;
							line-height: 24px;
							color: #13161A;
						}
						.component-tab-all__section-brand{
							display: flex;
							gap: 20px;
							margin-bottom: 12px;
							overflow-x: scroll;
							overflow-y: hidden;
							white-space: nowrap;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}
						.component-tab-all__section-brand::-webkit-scrollbar {
							display: none;
						}
						.component-tab-all__section-image-brand{
							height: 50px;
							width: 100px;
							padding: 5px 10px;
						}
						.component-tab-all__image-brand{
							width: -webkit-fill-available;
							height: -webkit-fill-available;
						}
						.component-tab-all__product{
							display: flex;
							column-gap: 12px;
							overflow-x: scroll;
							overflow-y: hidden;
							white-space: nowrap;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}

						.component-tab-all__product::-webkit-scrollbar {
							display: none;
						}

						.component-tab-all__button-view-all{
							font-family: 'Creato Display';
							font-style: normal;
							font-weight: 700;
							font-size: 14px;
							line-height: 22px;
							color: #DB284E;
							background-color: transparent;
							border: none;
							cursor: pointer;
						}
						.component-tab-all__users{
							display: flex;
							overflow-x: scroll;
							overflow-y: hidden;
							-ms-overflow-style: none; /* IE and Edge */
							scrollbar-width: none; /* Firefox */
						}
						.component-tab-all__users::-webkit-scrollbar {
							display: none;
						}
						.component-tab-all__section-image-error{
							flex-direction: column;
							display: flex;
    						justify-content: center;
							align-items: center;
							padding: 45.5px 0 26px;
						}
						.component-tab-topic__image-error{
							width: 200px;
							height: 200px;
							margin-bottom: 24px;

						}
						.component-tab-topic__title{
							margin-bottom: 8px;
							font-family: 'Creato Display' !important;
						}
						.component-tab-topic__sub_title{
							font-family: 'Creato Display' !important;
						}
					`}
			</style>
		</div>
	);

};

export default Mobile;
